import mapValuesForSubmit from './mapValuesForSubmit';
import CompanyService from 'App/services/CompanyService';

function createUser(values) {
    const user = mapValuesForSubmit(values);

    return CompanyService.createCompanyUser(user);
}

export default createUser;
